/**
 * The standard 2nd Skies brand watermark: a large, faint, centred brand icon
 * that sits behind an app's content so shared screenshots always carry our mark.
 *
 * Render it as the FIRST child of a positioned (position: relative) pane, and
 * ensure the real content sits above it (z-index: 1). The icon is served from
 * each app's public root as /01-Icon-White.png.
 */
export function Watermark(): JSX.Element {
  return <div className="app-watermark" aria-hidden="true" />;
}
